<div class="followers" dir="rtl">

  <header class="followers__head">
    <h2 class="followers__title">ניהול עוקבים</h2>
    <p class="followers__lead">
      מי עוקב אחרי המודעות שלך, ומי חסמת. חסימה מסירה את המשתמש מרשימת העוקבים
      ומונעת ממנו לעקוב שוב.
    </p>
  </header>

  <nav class="tabs" role="tablist">
    <button type="button" class="tabs__btn" role="tab"
            [class.tabs__btn--on]="tab === 'followers'"
            [attr.aria-selected]="tab === 'followers'"
            (click)="selectTab('followers')">
      עוקבים
      <span class="tabs__count" *ngIf="followers.length">{{ followers.length }}</span>
    </button>
    <button type="button" class="tabs__btn" role="tab"
            [class.tabs__btn--on]="tab === 'blocked'"
            [attr.aria-selected]="tab === 'blocked'"
            (click)="selectTab('blocked')">
      חסומים
      <span class="tabs__count" *ngIf="blocked.length">{{ blocked.length }}</span>
    </button>
  </nav>

  <p class="alert" role="alert" *ngIf="error">{{ error }}</p>

  <div class="state" *ngIf="currentLoading">
    <div class="spinner"></div>
  </div>

  <ng-container *ngIf="!currentLoading">

    <p class="empty" *ngIf="currentList.length === 0">{{ emptyMessage }}</p>

    <ul class="rows" *ngIf="currentList.length > 0">
      <li class="row" *ngFor="let p of currentList">
        <a class="row__who" [routerLink]="['/seller', p.id]">
          <span class="avatar">
            <img *ngIf="avatarOf(p)" [src]="avatarOf(p)" [alt]="displayName(p)" />
            <span *ngIf="!avatarOf(p)" class="avatar__initials">{{ initials(p) }}</span>
          </span>
          <span class="row__text">
            <span class="row__name">
              {{ displayName(p) }}
              <span class="vip" *ngIf="p.is_vip">VIP</span>
            </span>
            <span class="row__meta" *ngIf="p.store?.subtitle">{{ p.store.subtitle }}</span>
            <span class="row__meta" *ngIf="tab === 'blocked' && blockedDate(p)">
              נחסם ב־{{ blockedDate(p) }}
            </span>
          </span>
        </a>

        <button type="button" class="btn btn--danger"
                *ngIf="tab === 'followers'"
                [disabled]="busyId === p.id"
                (click)="askBlock(p)">
          {{ busyId === p.id ? '…' : 'חסום' }}
        </button>

        <button type="button" class="btn btn--ghost"
                *ngIf="tab === 'blocked'"
                [disabled]="busyId === p.id"
                (click)="unblock(p)">
          {{ busyId === p.id ? '…' : 'בטל חסימה' }}
        </button>
      </li>
    </ul>

    <div class="more" *ngIf="hasNext">
      <button type="button" class="btn btn--ghost"
              [disabled]="loadingMore" (click)="loadMore()">
        {{ loadingMore ? 'טוען…' : 'טען עוד' }}
      </button>
    </div>
  </ng-container>

  <!-- Confirmation: blocking is destructive and not obviously reversible,
       so it never happens on a single tap. -->
  <div class="modal" *ngIf="confirming" (click)="cancelBlock()">
    <div class="modal__box" (click)="$event.stopPropagation()">
      <p class="modal__text">
        האם לחסום את {{ displayName(confirming) }}? הם יוסרו מרשימת העוקבים שלך
        ולא יוכלו לעקוב אחריך.
      </p>
      <div class="modal__actions">
        <button type="button" class="btn btn--danger-solid" (click)="confirmBlock()">חסום</button>
        <button type="button" class="btn btn--ghost" (click)="cancelBlock()">ביטול</button>
      </div>
    </div>
  </div>
</div>
